import { BaseContainerModel } from '../base-container.model';

import {
  bl_pgw_merchant_contract_hdr_RowClass,
  bl_pgw_merchant_contract_hdr_RowInterface,
} from '../../dbschema';

export class MerchantContractContainerModel extends BaseContainerModel {
  bl_pgw_merchant_contract_hdr: bl_pgw_merchant_contract_hdr_RowInterface = new bl_pgw_merchant_contract_hdr_RowClass();
}
